import type { DashboardTileHeaderProps } from './dashboard-tile-header.types.ts';
import styles from './dashboard-tile-header.module.scss';

export function DashboardTileHeader({ children, className }: DashboardTileHeaderProps) {
  return <div className={`k-card-header ${styles.header} ${className}`}>{children}</div>;
}
